<script>export let color;
</script>

<style>
  div {
    font-size: 10px;
    background-color: var(--tag-color, gray);
    box-shadow: 0 4px 4px rgb(0 0 0 / 25%);
    border-radius: 0 6px;
    padding: 4px;
    white-space: nowrap;
    transform-origin: 100% 100%;
    transform: rotate(270deg) translateX(19px);
    text-transform: uppercase;
  }
</style>

<div style="--tag-color: {color}">
  <slot />
</div>
